import React from 'react';
import { UserEmulationForm } from './UserEmulationForm';
import { UserEmulationModalBody } from './UserEmulation.styles';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts';
export const UserEmulationBody = () => {
    const { t } = useGlobalization();
    return (React.createElement(UserEmulationModalBody, null,
        t('Please enter the email addresss of the user you wish to emulate.'),
        React.createElement(UserEmulationForm, null)));
};
